import { User } from './users'
import { RelatedProject, ServerProject } from './projects'
import { ServerTask } from './tasks'
import { Brand, Client, Country, Direction, Network, WorkType } from './refs/refs'
import { FileData } from './files'
import { FailedResponse, Query } from './response'
import { Bool, ID } from '../types/UtilityTypes'
import { ProjectWorkObject, WorkObject } from './objects'
import { Comment } from './comments'
import { Tag } from './tags'
import { NonEmptyArray } from 'fp-ts/es6/NonEmptyArray'
import { HistoryType } from '../constants/enums'
import { HistoryContent } from '../components/pages/projects/ProjectPage/Chat/factory-types'

export interface HistoryResources {
    user: Record<ID, User>,
    project: Record<ID, ServerProject>,
    task: Record<ID, ServerTask & { details: { init: ServerTask } }>,
    project_work_object: Record<ID, ProjectWorkObject>,
    target_user: Record<ID, User>,
    file: Record<ID, FileData>,
    comment: Record<ID, Comment>,
    tag: Record<ID, Tag>,
    type: Record<ID, WorkType>,
    manager: Record<ID, User>,
    client: Record<ID, Client>,
    brand: Record<ID, Brand>,
    direction: Record<ID, Direction>,
    work_type: Record<ID, WorkType>,
    network: Record<ID, Network>,
    countries: Record<ID, Country>,
    work_object: Record<ID, WorkObject>,
    status: Record<ID, { id: number, name: string }>,
    finplan: Record<ID, RelatedProject>,
    curator: Record<ID, User>,
}

export const EMPTY_RESOURCES: HistoryResources = {
    brand: {},
    client: {},
    comment: {},
    countries: {},
    direction: {},
    file: {},
    finplan: {},
    manager: {},
    network: {},
    project: {},
    project_work_object: {},
    status: {},
    tag: {},
    target_user: {},
    task: {},
    type: {},
    user: {},
    work_object: {},
    work_type: {},
    curator: {},
}

export interface ReadResponseData {
    id: ID,
    user_id: number,
    log_id: number,
    action_id: number,
    owner_id: number,
    owner_type: string,
    project_id: number,
    project_work_object_id: number,
    task_id: number,
    created_at: string,
    comment: null,
}

export type Owner = 'task' | 'comment' | 'project'

export type HistoryAction = {
    text: string,
    kind: 'user' | 'system',
    key: 'file' | 'comment' | string,
} & ({
    type: 'add' | 'delete',
    values: NonEmptyArray<HistoryContent>,
} | {
    type: 'change',
    values: [HistoryContent, HistoryContent]
})

export type HistoryData = ({
    type: 'project',
    project: ID,
} | {
    type: 'project_work_object',
    project: ID,
    project_work_object: ID,
} | {
    type: 'task',
    task: ID,
    project: ID,
    project_work_object: ID,
}) & {
    id: ID,
    kind: 'uer' | 'system' | 'mixed'
    owner_type: Owner,
    owner_id: ID,
    read: Bool,
    type: HistoryType,
    user: ID,
    created_at: string,
    actions: NonEmptyArray<HistoryAction>,
}

export interface NormalizedHistory {
    data: HistoryData[],
    resources: HistoryResources,
}

export interface HistorySuccessResponse {
    success: true,
    rows: NormalizedHistory,
    owner: ServerProject | ProjectWorkObject | ServerTask,
    total: number,
}

export type HistoryResponse = HistorySuccessResponse | FailedResponse

export type HistoryFilterType = 'files' | 'comments'

export type HistoryQuery = Query & {
    //type?: HistoryFilterType[]
    kind?: string
}

export const isResultHistory = (data: HistoryData, resources: HistoryResources): boolean =>
    data.actions.some(action => action.key === 'comment' && resources.comment[action.values[0] as ID]?.resulted)
